import { createTheme, rem } from "@mantine/core";

const appTheme = createTheme({
  fontFamily: "Montserrat, sans-serif",
  autoContrast: true,
  luminanceThreshold: 0.3,
  primaryColor: "primary",
  colors: {
    primary: [
      "#eaf3ff",
      "#cfe4ff",
      "#a5cdff",
      "#73aff4",
      "#3c8fe7",
      "#2471b7",
      "#005aab",
      "#004f98",
      "#003d79",
      "#002754",
    ],
    neutral: [
      "#181818",
      "#282828",
      "#404040",
      "#555555",
      "#707072",
      "#374151",
      "#949494",
      "#b8b8b8",
      "#e7e7e7",
      "#fafafa",
    ],
    white: [
      "#ffffff",
      "#fefefe",
      "#fdfdfd",
      "#fcfcfc",
      "#fafafa",
      "#f5f5f5",
      "#f0f0f0",
      "#e9e9e9",
      "#e3e3e3",
      "#dedede",
    ],
    black: [
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
    ],
    success: [
      "#f0fdf4",
      "#dcfce7",
      "#bbf7d0",
      "#86efac",
      "#4ade80",
      "#22c55e",
      "#16a34a",
      "#15803d",
      "#166534",
      "#14532d",
    ],
    warning: [
      "#fffbeb",
      "#fef3c7",
      "#fde68a",
      "#fcd34d",
      "#fbbf24",
      "#f59e0b",
      "#d97706",
      "#b45309",
      "#92400e",
      "#78350f",
    ],
    error: [
      "#fef2f2",
      "#fee2e2",
      "#fecaca",
      "#fca5a5",
      "#f87171",
      "#ef4444",
      "#dc2626",
      "#b91c1c",
      "#991b1b",
      "#7f1d1d",
    ],
  },
  fontSizes: {
    xs: rem(12),
    sm: rem(14),
    md: rem(16),
    lg: rem(18),
    xl: rem(20),
  },
  breakpoints: {
    xs: "640px",
    sm: "768px",
    md: "1024px",
    lg: "1280px",
    xl: "1536px",
  },
});

export default appTheme;
